import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    header: {
        "@media (max-width: 900px)": {
            paddingLeft: 0,
        },
    },
    switchButton: {
        //fontWeight: 500,
        size: "18px",
        color: "white",
        alignSelf: "left",
    },
    menuButton: {
        //fontWeight: 550,
        size: "18px",
        color: "white",
        alignSelf: "left",
        "&:hover": {
            backgroundColor: theme.palette.primary.light,
            color: "white",
        },
    },
    toolbar: {
        display: "flex",
        width: "100%",
        backgroundColor: theme.palette.primary.main,
        '@media print': { display: "none" },
        "& .MuiMenuItem-root": {
            color: "white",
        },
        "& .MuiMenuItem-root.Mui-selected": { /* Increase the specificity */
            color: theme.palette.secondary.main,
            backgroundColor: theme.palette.primary.main,
        },
    },
    appBarPadding: {
        paddingBottom: "64px"

    },
    subMenu: {
        display: "flex",
        justifyContent: "space-between",
        "& .MuiPaper-root": {
            backgroundColor: theme.palette.primary.main,
        },
        "& .MuiMenuItem-root": {
            color: "white",
        },
        "& .MuiMenuItem-root.Mui-selected": { /* Increase the specificity */
            color: theme.palette.secondary.main,
            backgroundColor: theme.palette.primary.main,
        }
    },
    picture: {
        marginRight: "36px"
    },
    envtag: {
        top: "10px",
        position: "absolute",
        left: "10px",
        color: "white",
        backgroundColor: "red",
        transform: "rotate(-30deg)",
        fontSize: "1.2rem",
        padding: "5px",
        borderRadius: "5px",
    },
}), { index: 1 });
